import { render } from "./add-category-target.vue?vue&type=template&id=7a5710e6&scoped=true"
import script from "./add-category-target.vue?vue&type=script&lang=js"
export * from "./add-category-target.vue?vue&type=script&lang=js"

import "./add-category-target.vue?vue&type=style&index=0&id=7a5710e6&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a5710e6"]])

export default __exports__